export const TYPE_SABAY_GAME_REVENUE = "TYPE_SABAY_GAME_REVENUE";
